import React from "react"

import ItemModelV2 from "../../../../../../../model2/item2/item-model"
import TasksView_Column from "../../../../../../../model2/column/column"
import FieldProto from "../../../../../../proto/field-proto"
import {ItemModelV2_CalculatedValues} from "../../../../../../../model2/item2/calculated/@type";

type Props = {
    style?          : any

    listItem        : ItemModelV2
    column          : TasksView_Column
    field           : FieldProto

    onMouseEnter    : callback
    onMouseLeave    : callback
}

// const debug = "FieldMessagesTotal_TableCellCalculated_NotHovered"
const debug = false

export default function FieldMessagesTotal_TableCellCalculated_NotHovered(props: Props) {

    const classes = Classes("cell-flex ui5-field-editable size-small ui5-txt-less-important-small", props.column.id, {
        // 'is-expanded-calculated': props.listItem.isGroup && !props.listItem.view.isCollapsed
    })

    const showSummaryView   = /*props.listItem.isGroup ||*/ props.listItem.view.isCollapsed
    let notHoveredContent   = null
    let aggregateIcon

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item) || 0

    debug && console.log(debug, "renderNotHovered", showSummaryView, calculatedValues)

    if (showSummaryView && !!calculatedValues?.total.value /*&& calculatedValues.total.value != calculatedValues.own*/) {
        notHoveredContent = calculatedValues.total.value
        aggregateIcon = <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.column.aggregator?.icon)}/>
    } else if (ownValue > 0) {
        notHoveredContent = (
            <>
                <div className={Classes("ui5-ico-13 m-r-5 m-t-1 i5-chat")}/>
                {ownValue}
            </>
        )
    }

    return (
        <div className      = {classes}
             style          = {props.style}
             onMouseEnter   = {props.onMouseEnter}
             onMouseLeave   = {props.onMouseLeave}>
            {aggregateIcon}

            {notHoveredContent}
        </div>
    )
}
